/* Carska: nawigacja (mega-menu, wyszukiwarka z podpowiedziami, panel mobilny). Zero bibliotek. */
(function () {
  'use strict';
  var doc = document;
  var nav = doc.querySelector('[data-nav]');
  if (!nav) return;

  var mqMobile = window.matchMedia('(max-width: 760px)');
  var mqNoHover = window.matchMedia('(hover: none)');

  function qs(s, r) { return (r || doc).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Mega-menu ---------- */
  var sklep = qs('[data-nav-sklep]', nav);
  var sklepLink = qs('[data-nav-sklep-link]', nav);
  var mega = qs('[data-mega]', nav);
  var megaOpen = false, megaOpenT = null, megaCloseT = null, megaSuppress = false;

  function openMega() {
    clearTimeout(megaCloseT);
    if (megaOpen || !mega) return;
    megaOpen = true;
    mega.classList.add('is-open');
    sklep.classList.add('is-open');
    sklepLink.setAttribute('aria-expanded', 'true');
  }
  function closeMega() {
    clearTimeout(megaOpenT);
    if (!megaOpen || !mega) return;
    megaOpen = false;
    mega.classList.remove('is-open');
    sklep.classList.remove('is-open');
    sklepLink.setAttribute('aria-expanded', 'false');
  }
  if (sklep && sklepLink && mega) {
    sklep.addEventListener('mouseenter', function () {
      if (mqMobile.matches || mqNoHover.matches || searchOpen) return;
      clearTimeout(megaCloseT);
      megaOpenT = setTimeout(openMega, 80);
    });
    sklep.addEventListener('mouseleave', function () {
      clearTimeout(megaOpenT);
      megaSuppress = false;
      megaCloseT = setTimeout(closeMega, 120);
    });
    sklep.addEventListener('focusin', function () {
      if (mqMobile.matches || mqNoHover.matches || megaSuppress) return;
      openMega();
    });
    sklep.addEventListener('focusout', function (e) {
      if (sklep.contains(e.relatedTarget)) return;
      megaSuppress = false;
      closeMega();
    });
    sklepLink.addEventListener('click', function (e) {
      if (mqNoHover.matches && !megaOpen && !mqMobile.matches) { e.preventDefault(); openMega(); }
    });
    sklepLink.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        megaSuppress = false;
        openMega();
        var first = qs('a', mega);
        if (first) first.focus();
      }
    });
  }

  /* ---------- Podpowiedzi wyszukiwania ---------- */
  function stripBrand(t) { return String(t || '').replace(/^Carska\s+/i, ''); }
  function hl(text, q) {
    var i = text.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0) return esc(text);
    return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
  }
  function money(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    var r = Math.round(n * 100) / 100;
    return (r % 1 === 0 ? String(r) : r.toFixed(2).replace('.', ',')) + ' zł';
  }
  function sized(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var ICON_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12V4h8l9 9-8 8-9-9z"/><circle cx="7.5" cy="8.5" r="1.3"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function renderSuggest(q, res) {
    var prods = (res.products || []).filter(function (product) {
      var handle = product.handle || (product.url || '').split('/products/')[1] || '';
      handle = handle.split('?')[0];
      return handle !== '2x-carska-kompleks-ziolowy-betaina-pepsyna-gratis' &&
        handle !== 'zakwas-zapas-2-miesiace-3-prezenty';
    }).slice(0, 4);
    var colls = res.collections || [];
    var h = '';
    if (!prods.length && !colls.length) {
      h += '<p class="ck-sg-empty">Brak podpowiedzi dla „' + esc(q) + '”. Sprawdź pisownię albo zobacz wszystkie wyniki.</p>';
    } else {
      h += '<div class="ck-sg-grid">';
      if (prods.length) {
        h += '<div class="ck-sg-col"><p class="ck-sg-head">Produkty<span>' + prods.length + '</span></p><ul class="ck-sg-list">';
        prods.forEach(function (p) {
          var img = sized(p.image || (p.featured_image && p.featured_image.url), 96);
          h += '<li><a class="ck-sg-prod" href="' + esc(p.url) + '">' +
            '<span class="ck-sg-img">' + (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '') + '</span>' +
            '<span class="ck-sg-title">' + hl(stripBrand(p.title), q) + '</span>' +
            '<span class="ck-sg-price">' + esc(money(p.price)) + '</span></a></li>';
        });
        h += '</ul></div>';
      }
      if (colls.length) {
        h += '<div class="ck-sg-col"><p class="ck-sg-head">Kolekcje<span>' + colls.length + '</span></p><ul class="ck-sg-list">';
        colls.forEach(function (c) {
          h += '<li><a class="ck-sg-coll" href="' + esc(c.url) + '">' + ICON_TAG + '<span class="ck-sg-title">' + hl(c.title, q) + '</span></a></li>';
        });
        h += '</ul></div>';
      }
      h += '</div>';
    }
    h += '<a class="ck-sg-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Pokaż wszystkie wyniki' + ICON_ARROW + '</a>';
    return h;
  }

  function renderError(q) {
    return '<p class="ck-sg-empty">Nie udało się pobrać podpowiedzi. Spróbuj ponownie za chwilę.</p>' +
      '<a class="ck-sg-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Pokaż wszystkie wyniki' + ICON_ARROW + '</a>';
  }

  function bindSuggest(input, panel) {
    var timer = null, ctrl = null, last = '';
    function hide() {
      if (ctrl) { ctrl.abort(); ctrl = null; }
      panel.classList.remove('is-open');
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      last = '';
    }
    function show(html) {
      panel.innerHTML = html;
      panel.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      if (q === last) return;
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=hide';
      fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) { var err = new Error('HTTP ' + r.status); err.name = 'HttpError'; throw err; }
          return r.json();
        })
        .then(function (d) {
          if (!d || input.value.trim() !== q) return;
          show(renderSuggest(q, (d.resources && d.resources.results) || {}));
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          if (input.value.trim() !== q) return;
          show(renderError(q));
        });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && !panel.classList.contains('is-open')) { last = ''; run(); }
    });
    input.form && input.form.addEventListener('submit', function (e) {
      if (input.value.trim().length === 0) { e.preventDefault(); input.focus(); }
    });
    return { hide: hide, clear: function () { input.value = ''; hide(); } };
  }

  /* ---------- Wyszukiwarka na pasku (desktop) ---------- */
  var searchBtn = qs('[data-nav-search]', nav);
  var searchForm = qs('[data-search-form]', nav);
  var searchInput = searchForm ? qs('[data-search-input]', searchForm) : null;
  var searchClose = searchForm ? qs('[data-search-close]', searchForm) : null;
  var searchPanel = searchInput ? doc.getElementById(searchInput.getAttribute('aria-controls')) : null;
  var searchOpen = false, searchSg = null;

  if (searchInput && searchPanel) searchSg = bindSuggest(searchInput, searchPanel);

  function openSearch() {
    if (mqMobile.matches) { openMobile(true); return; }
    if (!searchForm) return;
    if (searchOpen) { searchInput.focus(); return; }
    closeMega();
    searchOpen = true;
    nav.classList.add('is-search');
    searchBtn.setAttribute('aria-expanded', 'true');
    searchInput.tabIndex = 0;
    if (searchClose) searchClose.tabIndex = 0;
    setTimeout(function () { searchInput.focus(); }, 30);
  }
  function closeSearch(restoreFocus) {
    if (!searchOpen) return;
    searchOpen = false;
    if (searchSg) searchSg.clear();
    nav.classList.remove('is-search');
    searchBtn.setAttribute('aria-expanded', 'false');
    searchInput.tabIndex = -1;
    if (searchClose) searchClose.tabIndex = -1;
    if (restoreFocus) searchBtn.focus();
  }
  function syncSearchBtn() {
    if (!searchBtn) return;
    searchBtn.setAttribute('aria-controls', mqMobile.matches ? 'ck-mobile-panel' : (searchForm && searchForm.id ? searchForm.id : 'ck-search'));
  }
  if (searchBtn) {
    syncSearchBtn();
    searchBtn.addEventListener('click', function () { searchOpen ? closeSearch(true) : openSearch(); });
  }
  if (searchClose) {
    searchClose.addEventListener('click', function () { closeSearch(true); });
  }

  /* ---------- Panel mobilny ---------- */
  var burger = qs('[data-nav-burger]', nav);
  var mpanel = qs('[data-mobile-panel]');
  var moverlay = qs('[data-mobile-overlay]');
  var mclose = mpanel ? qs('[data-mobile-close]', mpanel) : null;
  var minput = mpanel ? qs('[data-search-input]', mpanel) : null;
  var mpanelSg = minput ? doc.getElementById(minput.getAttribute('aria-controls')) : null;
  var mobileOpen = false, mobileSg = null;

  if (minput && mpanelSg) mobileSg = bindSuggest(minput, mpanelSg);

  function openMobile(focusSearch) {
    if (!mpanel) return;
    if (!mobileOpen) {
      mobileOpen = true;
      mpanel.classList.add('is-open');
      if (moverlay) moverlay.classList.add('is-open');
      mpanel.setAttribute('aria-hidden', 'false');
      mpanel.inert = false;
      if (burger) burger.setAttribute('aria-expanded', 'true');
      doc.body.classList.add('ck-nav-open');
    }
    var target = focusSearch && minput ? minput : mclose;
    if (target) setTimeout(function () { target.focus(); }, 60);
  }
  function closeMobile(restoreFocus) {
    if (!mobileOpen) return;
    mobileOpen = false;
    mpanel.classList.remove('is-open');
    if (moverlay) moverlay.classList.remove('is-open');
    mpanel.setAttribute('aria-hidden', 'true');
    mpanel.inert = true;
    if (burger) burger.setAttribute('aria-expanded', 'false');
    doc.body.classList.remove('ck-nav-open');
    if (mobileSg) mobileSg.clear();
    if (restoreFocus && burger) burger.focus();
  }
  if (burger) burger.addEventListener('click', function () { mobileOpen ? closeMobile(true) : openMobile(false); });
  if (mclose) mclose.addEventListener('click', function () { closeMobile(true); });
  if (moverlay) moverlay.addEventListener('click', function () { closeMobile(true); });
  if (mpanel) {
    mpanel.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) closeMobile(false);
    });
    /* Pulapka fokusu wewnatrz dialogu */
    mpanel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !mobileOpen) return;
      var items = qsa('a[href], button:not([disabled]), input:not([disabled]), summary', mpanel).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  mqMobile.addEventListener('change', function (e) {
    if (!e.matches) closeMobile(false);
    else { closeSearch(false); closeMega(); }
    syncSearchBtn();
  });

  /* ---------- Globalne: klik poza, Escape ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (searchOpen && !searchForm.contains(t) && !searchPanel.contains(t) && !searchBtn.contains(t)) closeSearch(false);
    if (megaOpen && !sklep.contains(t)) closeMega();
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (mobileOpen) { closeMobile(true); return; }
    if (searchOpen) { closeSearch(true); return; }
    if (megaOpen) {
      var inside = sklep.contains(doc.activeElement);
      if (inside) { megaSuppress = true; closeMega(); sklepLink.focus(); }
      else closeMega();
    }
  });
})();
